module.exports = __webpack_public_path__ + "static/img/deepseek.63ca6d48.png";